import React from 'react';
import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import VideoModal from "../videoModal";

export const VideoFeature = (props) => {

    const sc = props.slice.primary;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;



    return (
        <section className={"relative bg-" + (bg) + " " + (space)}>
            <div className="wrapper">
                <div className="-mt-16 md:-mt-28 flex flex-col md:flex-row justify-between items-center gap-12 md:gap-24 rounded-2xl p-6 md:p-12 bg-white border border-grey-md hover:border-grey">
                    <div className="w-full md:w-1/2 content-side text-grey">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="text-sm text-grey-darker">June 30, 2025</div>
                            <span className="text-2xl text-grey-md hidden md:block">•</span>
                            <div className="text-sm text-grey-darker">Season 1</div>
                            <span className="text-2xl text-grey-md hidden md:block">•</span>
                            <div className="text-sm text-grey-darker">18:39</div>
                        </div>
                        <div className="label bg-opacity-10 font-bold uppercase tracking-widest text-xs mb-1 text-accessible-teal">{sc.label}</div>
                        <PrismicRichText field={sc.section_title.richText} />
                        <PrismicRichText field={sc.section_content.richText} />
                        <div className="flex gap-3 mt-6 w-full md:w-4/5">
                            <a href="" className="block">
                                <img src="https://images.prismic.io/qh-cs/aH_MA1GsbswqTJhB_listen-on-spotify-logo.png?auto=format,compress" alt="Listen on Spotify" className="" />
                            </a>
                            <a href="" className="block">
                                <img src="https://images.prismic.io/qh-cs/aH_N-FGsbswqTJh1_listen-on-apple-logo.png?auto=format,compress" alt="Listen on Apple podcasts" className="" />
                            </a>
                        </div>
                    </div>
                    <div className="w-full md:w-1/2 relative">
                        <VideoModal ytId={sc.youtube_id} />
                        <GatsbyImage image={getImage(sc.youtube_image)} className="rounded-2xl hidden md:block" alt={sc.youtube_image.alt} />
                        <div className="video-wrapper block lg:hidden">
                            <iframe
                            src={"https://www.youtube.com/embed/" + sc.youtube_id + "?si=DsxYzoUGr8BEvb22"}
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            title={sc.section_title.text}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

